import * as React from 'react'
import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import * as style from './hidden-scroll-item.module.scss'

const HiddenScrollItem = ({ id, positionData = 100 }) => {
  const [position, setPosition] = useState(100)

  useEffect(() => {
    const header = document.querySelector('header')
    if (header) {
      const headerHeight = header.offsetHeight
      setPosition(headerHeight + positionData)
    }
  }, [])

  return (
    <div
      style={{ top: `-${position}px` }}
      className={style.scrollItem}
      id={id}
    />
  )
}

HiddenScrollItem.propTypes = {
  id: PropTypes.string.isRequired,
}
export default HiddenScrollItem
